module.exports = __webpack_public_path__ + "static/img/2_1_1.c205aa94.jpg";